'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import InstitutionalIntegrationContent from './components/InstitutionalIntegrationContent';

export default function InstitutionalIntegrationPage() {
  return (
    <AppLayout role="admin" campusMode="pro">
      <InstitutionalIntegrationContent />
    </AppLayout>
  );
}
